import { Component, Inject, OnInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SharedModule } from '../../shared/shared.module';
import { MatListModule } from '@angular/material/list';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-nri--members-list',
  templateUrl: './nri-members-list.component.html',
  styleUrl: './nri-members-list.component.scss'
})
export class NriMembersListComponent implements OnInit {
  baseUrl = environment.imageURL;
  nriListData: any = [];
  originalNriListData: any[] = [];
  sub2 = new Subscription;

  constructor(
    private mainService: MainService,
    private _bottomSheet: MatBottomSheet,
  ) {
    this.sub2 = this.mainService.sendFilterData().subscribe(res => {      
      this.nriListData = this.originalNriListData.filter((user: any) => {        
        const villageTrimmed = user.village_id.toString().trim().toLowerCase();
        const resVillageTrimmed = res.village_id.toString().trim().toLowerCase();
        const bloodGroupMatch = !res.blood_group || user.blood_group.toLowerCase() === res.blood_group.toLowerCase();        
        const cityTrimmed = user.current_city_id.toString().trim().toLowerCase();
        const cityNameMatchFormat = res.city_id.toString().trim().toLowerCase();
        const villageNameMatch = !res.village_id || villageTrimmed === resVillageTrimmed;
        const cityNameMatch = !res.city_id || cityTrimmed === cityNameMatchFormat;

        return bloodGroupMatch && villageNameMatch && cityNameMatch;
      });
    })
  }

  searchMember(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.nriListData = [...this.originalNriListData];
      return;
    }
    this.nriListData = this.originalNriListData.filter((data: any) => {
      return data.name.toLowerCase().includes(filterValue) ||
        data.contact_no.includes(filterValue);
    });
  }

  openBottomSheet(): void {
    this._bottomSheet.open(FilterMemberForm, {
      data: this.nriListData,
    });
  }

  ngOnInit() {
    this.getNriList();
  }

  getNriList() {
    let data = {
      user_id: 0,
      name: "",
      address: "",
      contact_no: "",
      whatsapp_no: "",
      business: "",
      office_contact: "",
      office_address: "",
      village_id: 0,
      current_city_id: 0,
      education: "",
      dob: "",
      blood_group: "",
      image: "", // Assuming 'image' is a property of the member object
      //image_file:"",
      relation_id: 0,
      main_member_id: 0,
      maternal_name: "",
      maternal_village_id: 0,
      is_verified: 0,
      user_type_id: 0,
      password: "",
      created_by: 0,
      Action: 'NRIMEMBER',
    };
    this.mainService.putApi(ApiUrls.verifiedMemberList, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.nriListData = res.user;
        this.originalNriListData = res.user;
      }
    });
  }

}


@Component({
  selector: 'app-filter-member',
  templateUrl: 'filter-member.component.html',
  standalone: true,
  imports: [MatListModule, CommonModule, SharedModule],
})
export class FilterMemberForm implements OnInit {
  cityList: any = [];
  dataDistrictList: any = [];
  subdivisionList: any = [];
  villageList: any = [];
  selectedDistrictId: any = 0;
  selectedSubdivisionId: any = 0;
  filter_memberForm: FormGroup;
  
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<FilterMemberForm>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private mainService: MainService, 
    private fb: FormBuilder ) {
    this.filter_memberForm = this.fb.group({
      blood_group: [''],
      district_name: [''],
      subdivision_name: [''],
      village_name: [''],
      contact_no: [''],
      city_name: ['']
    })

    // for (const key in data) {
    //   const element = data[key];
    //   this.villageList.push(element.village_name);
    // }
    // this.villageList = this.villageList.filter((value: any, index: any, array: any) => array.indexOf(value) === index);
  }
  ngOnInit(): void {
    this.getDistrict()
    this.getCity()
  }


  getCity() {
    this.mainService.getApi(ApiUrls.cityList).subscribe((res: any) => {
      this.cityList = res.city.filter((x: any) => x.is_active == 1);
    })
  }

  getDistrict() {
    this.mainService.getApi(ApiUrls.districtList).subscribe((res: any) => {
      this.dataDistrictList = res.district.filter((x: any) => x.is_active == 1);
    })
  }

  onDistrict_Id(event: any) {
    const selectedDistrictId = event.target.value;
    const selectedDistrict = this.dataDistrictList.find((district: any) => district.district_id == selectedDistrictId);
    this.selectedDistrictId = selectedDistrictId;
    this.getSubdivision(this.selectedDistrictId);
  }

  getSubdivision(id: any) {
    this.mainService.getApi(ApiUrls.subdivisionListSelect + id).subscribe((res: any) => {
      this.subdivisionList = res.subdivision.filter((x: any) => x.is_active == 1);
    });
  }

  onSubdivision_Id(event: any) {
    const selectedSubdivisionId = event.target.value;
    const selectedSubdivision = this.subdivisionList.find((subdivision: any) => subdivision.subdivision_id == selectedSubdivisionId);
    this.selectedSubdivisionId = selectedSubdivisionId;
    this.getVillages(this.selectedSubdivisionId);
  }

  getVillages(id: any) {
    this.mainService.getApi(ApiUrls.villageListSelect + id).subscribe((res: any) => {
      this.villageList = res.village.filter((x: any) => x.is_active == 1);
    });
  }

  Cancel() {
    this._bottomSheetRef.dismiss();
  }

  submit() {
    let data = {
      blood_group: this.filter_memberForm.value.blood_group,
      district_id: this.filter_memberForm.value.district_name,
      subdivision_id: this.filter_memberForm.value.subdivision_name,
      village_id: this.filter_memberForm.value.village_name,
      city_id: this.filter_memberForm.value.city_name,
      contact_no: this.filter_memberForm.value.contact_no,
    }
    this.mainService.getFilterData(data);
    this._bottomSheetRef.dismiss();
  }

}
